/* Toe Converter (snippets/aoc-toe-converter.liquid).
   Same math as IntelAlign's ToeConversion (GridPlate.swift): minutes and degrees are angles;
   millimeters and inches are a chord across the WHEEL diameter, so
     degrees = atan(length_mm / (diameter_in * 25.4)) in degrees
     length_mm = diameter_in * 25.4 * tan(degrees)
   Per wheel. The pure functions are Node-requireable for the tests; the page wiring follows. */
(function (root) {
  'use strict';

  var MM_PER_IN = 25.4;
  var DIA_MIN = 4, DIA_MAX = 36; // the app's plausible wheel range, inches

  function toDegrees(value, unit, diaIn) {
    if (unit === 'deg') return value;
    if (unit === 'min') return value / 60;
    var mm = unit === 'in' ? value * MM_PER_IN : value;
    return Math.atan(mm / (diaIn * MM_PER_IN)) * 180 / Math.PI;
  }

  function fromDegrees(deg, unit, diaIn) {
    if (unit === 'deg') return deg;
    if (unit === 'min') return deg * 60;
    var mm = diaIn * MM_PER_IN * Math.tan(deg * Math.PI / 180);
    return unit === 'in' ? mm / MM_PER_IN : mm;
  }

  /* All four units from one entry, or an error message. */
  function convert(value, unit, diaIn) {
    if (!isFinite(value) || value < 0) return { error: 'Enter toe as a number, 0 or more.' };
    if (!isFinite(diaIn) || diaIn < DIA_MIN || diaIn > DIA_MAX) {
      return { error: 'Enter a wheel diameter between ' + DIA_MIN + ' and ' + DIA_MAX + ' inches.' };
    }
    var deg = toDegrees(value, unit, diaIn);
    return { mm: fromDegrees(deg, 'mm', diaIn), in: fromDegrees(deg, 'in', diaIn), min: deg * 60, deg: deg };
  }

  function format(unit, v) {
    if (unit === 'mm') return v.toFixed(2) + ' mm';
    if (unit === 'in') return v.toFixed(3) + ' in';
    if (unit === 'min') return v.toFixed(1) + '′';
    return v.toFixed(3) + '°';
  }

  var api = { toDegrees: toDegrees, fromDegrees: fromDegrees, convert: convert, format: format };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }

  function wire(card) {
    var value = card.querySelector('[data-tc-value]');
    var unit = card.querySelector('[data-tc-unit]');
    var dia = card.querySelector('[data-tc-dia]');
    var err = card.querySelector('[data-tc-error]');
    var results = card.querySelector('[data-tc-results]');
    function update() {
      var r = convert(parseFloat(value.value), unit.value, parseFloat(dia.value));
      if (r.error) { err.textContent = r.error; err.hidden = false; results.classList.add('is-stale'); return; }
      err.hidden = true; results.classList.remove('is-stale');
      ['mm', 'in', 'min', 'deg'].forEach(function (u) {
        card.querySelector('[data-tc-out="' + u + '"]').textContent = format(u, r[u]);
        card.querySelector('[data-tc-row="' + u + '"]').classList.toggle('is-entered', u === unit.value);
      });
    }
    [value, unit, dia].forEach(function (el) { el.addEventListener('input', update); el.addEventListener('change', update); });
    update();
  }
  document.querySelectorAll('[data-tc]').forEach(wire);
})(this);
